var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
var KtsTaskService = /** @class */ (function (_super) {
    __extends(KtsTaskService, _super);
    function KtsTaskService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this.fieldComps = [];
        return _this;
    }
    KtsTaskService.prototype.sortItems = function (items) {
        items.sort(function (a, b) {
            if (a.disp_order < b.disp_order) {
                return -1;
            }
            if (a.disp_order > b.disp_order) {
                return 1;
            }
            return 0;
        });
    };
    KtsTaskService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var check = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkVal(item.name)) {
                check = false;
            }
            else if (item.task_other_field_m.length > 0) {
                for (var _a = 0, _b = item.task_other_field_m; _a < _b.length; _a++) {
                    var field = _b[_a];
                    if (!this.colservice.checkVal(field.name)) {
                        check = false;
                        break;
                    }
                }
            }
            if (!check) {
                break;
            }
        }
        if (!check) {
            this.colservice.addError(this.fieldComps);
        }
        return check;
    };
    KtsTaskService.prototype.resetFieldComp = function () {
        this.fieldComps = [];
    };
    KtsTaskService.prototype.setFieldComp = function (compName) {
        this.fieldComps.push(compName);
    };
    KtsTaskService.prototype.getFieldComp = function () {
        return this.fieldComps;
    };
    KtsTaskService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsTaskService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return KtsTaskService;
}(ContentBaseService));
export { KtsTaskService };
var Task = /** @class */ (function () {
    function Task() {
        this.$type = "post" /* Post */;
        this.$editable = true; // step5の最後のみfalse
        this.task_other_field_m = [];
    }
    return Task;
}());
export { Task };
var TaskOtherField = /** @class */ (function () {
    function TaskOtherField() {
    }
    return TaskOtherField;
}());
export { TaskOtherField };
var Template = /** @class */ (function () {
    function Template() {
        this.cols = [];
    }
    return Template;
}());
var TaskTemplate = /** @class */ (function () {
    function TaskTemplate(msg, readonly) {
        this.file = new Template();
        this.confirm = new Template();
        this.standard = new Template();
        this.onsite = new Template();
        this.onsite_notime = new Template();
        this.construction = new Template();
        this.estimate = new Template();
        this.order = new Template();
        this.completion = new Template();
        this.inspection = new Template();
        this.name = {};
        this.field = [];
        var width100per = { formClass: { width: '100per' } };
        var dateValue = msg['au.COMPONENT.KtsTaskComponent.label.date'];
        var datetimeValue = msg['au.COMPONENT.KtsTaskComponent.label.datetime'];
        var necessityValue = msg['au.COMPONENT.KtsTaskComponent.label.select_necessity'];
        var confirmValue = msg['au.COMPONENT.KtsTaskComponent.label.select_is_ok'];
        var note2 = msg['au.COMPONENTS.label.task_note'];
        this.name = {
            label: msg['au.COMPONENTS.label.task_name'],
            key: 'name',
            controlType: 'text',
            readonly: readonly,
            required: true,
            params: width100per
        };
        this.field = [{
                label: msg['au.COMPONENTS.label.task_other_field'],
                key: 'task_other_field_m',
                readonly: readonly,
                items: [{
                        key: 'id',
                        hidden: true
                    }, {
                        key: 'name',
                        controlType: 'text',
                        required: true,
                        params: width100per
                    }]
            }];
        var colPlanDate = {
            label: msg['au.COMPONENTS.label.task_plan_date'],
            key: 'plan_date',
            readonly: true
        };
        var colActDate = {
            label: msg['au.COMPONENTS.label.task_act_date'],
            key: 'act_date',
            readonly: true
        };
        var necessity = {
            label: msg['au.COMPONENTS.label.task_necessity'],
            key: 'necessity',
            readonly: true
        };
        var confirm = {
            label: msg['au.COMPONENTS.label.task_is_ok'],
            key: 'is_ok',
            readonly: true
        };
        this.file = {
            note1: msg['au.COMPONENTS.label.task_note_file'],
            note2: note2,
            cols: [necessity, colPlanDate, colActDate, {
                    label: msg['au.COMPONENTS.label.task_file_genre'],
                    key: 'documents_genre_id',
                    readonly: true
                }, {
                    label: msg['au.COMPONENTS.label.task_file_title'],
                    key: 'title',
                    readonly: true
                }, {
                    label: msg['au.COMPONENTS.label.task_referrer_type'],
                    key: 'type',
                    readonly: true
                }, {
                    label: msg['au.COMPONENTS.label.task_file'],
                    key: 'file',
                    readonly: true
                }, confirm],
            values: {
                necessity: necessityValue,
                plan_date: dateValue,
                act_date: dateValue,
                documents_genre_id: msg['au.COMPONENT.KtsTaskComponent.label.select'],
                type: msg['au.COMPONENT.KtsTaskComponent.label.select'],
                title: msg['au.COMPONENT.KtsTaskComponent.label.text'],
                file: msg['au.COMPONENT.KtsTaskComponent.label.file'],
                is_ok: confirmValue
            }
        };
        this.construction = this.onsite = {
            note1: msg['au.COMPONENTS.label.task_note_visit'],
            note2: note2,
            cols: [necessity, {
                    label: msg['au.COMPONENTS.label.task_plan_datetime'],
                    readonly: true,
                    items: [{
                            key: 'plan_start_datetime'
                        }, {
                            label: '~',
                            controlType: 'label'
                        }, {
                            key: 'plan_end_datetime'
                        }]
                }, {
                    label: msg['au.COMPONENTS.label.task_act_datetime'],
                    readonly: true,
                    items: [{
                            key: 'act_start_datetime'
                        }, {
                            label: '~',
                            controlType: 'label'
                        }, {
                            key: 'act_end_datetime'
                        }]
                }, {
                    label: msg['au.COMPONENTS.label.task_partner_company'],
                    key: 'partner_company_m_id',
                    readonly: true
                }, {
                    label: msg['au.COMPONENTS.label.task_secondary_partner_company'],
                    key: 'secondary_partner_company_m_id',
                    readonly: true
                }, confirm],
            values: {
                necessity: necessityValue,
                plan_start_datetime: datetimeValue,
                plan_end_datetime: datetimeValue,
                act_start_datetime: datetimeValue,
                act_end_datetime: datetimeValue,
                partner_company_m_id: msg['au.COMPONENT.KtsTaskComponent.label.select'],
                secondary_partner_company_m_id: msg['au.COMPONENT.KtsTaskComponent.label.select'],
                is_ok: confirmValue
            }
        };
        this.onsite_notime = JSOG.parse(JSON.stringify(this.onsite));
        this.onsite_notime.cols[1].label = msg['au.COMPONENTS.label.task_plan_date'];
        this.onsite_notime.values.plan_start_datetime = dateValue;
        this.onsite_notime.values.plan_end_datetime = dateValue;
        this.confirm = this.inspection = {
            note1: msg['au.COMPONENTS.label.task_note_confirm'],
            note2: note2,
            cols: [necessity, colPlanDate, colActDate, confirm],
            values: {
                necessity: necessityValue,
                plan_date: dateValue,
                act_date: dateValue,
                is_ok: confirmValue
            }
        };
        this.estimate = this.order = this.completion = {
            note1: msg['au.COMPONENTS.label.task_note_material'],
            note2: note2,
            cols: [colPlanDate, colActDate, {
                    label: msg['au.COMPONENTS.label.task_material'],
                    items: [{
                            label: msg['au.COMPONENTS.label.task_material_label'],
                            controlType: 'label'
                        }]
                }],
            values: {
                plan_date: dateValue,
                act_date: dateValue
            }
        };
        this.standard = {
            note1: msg['au.COMPONENTS.label.task_note_standard'],
            note2: note2,
            cols: [necessity, colPlanDate, colActDate],
            values: {
                necessity: necessityValue,
                plan_date: dateValue,
                act_date: dateValue
            }
        };
    }
    return TaskTemplate;
}());
export { TaskTemplate };
//# sourceMappingURL=task.service.js.map